import { observer, inject } from 'mobx-react';
import * as React from 'react';
import { IAppOnlyStore } from 'stores/AllStores';
import { GroupList, GroupItem, GroupCreate } from '.';
import { LeadGroupModalStatus } from 'common/interfaces/provider';
import { Modal } from 'components/content';

// Styles
const s = require('./BusinessGroupModal.css');
const backArrow = require('assets/back icon.svg');

// Props
interface IBusinessGroupModal extends IAppOnlyStore {
  show: boolean;
}

// Component
@inject('store')
@observer
export class BusinessGroupModal extends React.Component<
  IBusinessGroupModal,
  {}
> {
  constructor(props: IBusinessGroupModal) {
    super(props);
  }

  public render() {
    const { leadGroup } = this.props.store;

    return (
      <Modal
        onModalClose={this.closeModal}
        show={this.props.show}
        title={this.modalTitle()}
        titleBarContent={
          leadGroup.modalStatus === LeadGroupModalStatus.OpenedOnGroupList &&
          leadGroup.leadGroups.length > 0
            ? this.renderStatesSearchBar()
            : null
        }
        titleBarIcons={
          leadGroup.modalStatus !== LeadGroupModalStatus.OpenedOnGroupList
            ? [
                {
                  key: 'back-arrow',
                  label: 'Back to group list',
                  showLabel: true,
                  icon: backArrow,
                  className: s.backArrow,
                  iconClassName: s.backArrowIcon,
                  onClick: this.handleBackToList,
                },
              ]
            : undefined
        }
      >
        {this.props.show && (
          <div className={s.state}>
            {leadGroup.modalStatus ===
            LeadGroupModalStatus.OpenedOnGroupList ? (
              <GroupList />
            ) : leadGroup.modalStatus ===
              LeadGroupModalStatus.OpenedOnCreateGroup ? (
              <GroupCreate />
            ) : leadGroup.modalStatus ===
              LeadGroupModalStatus.OpenedOnSpecificGroup ? (
              <GroupItem />
            ) : null}
          </div>
        )}
      </Modal>
    );
  }

  private renderStatesSearchBar = () => {
    return (
      <input
        className={s.statesSearchBar}
        type="text"
        placeholder="Search group..."
        onChange={this.handleSearchChange}
        value={this.props.store.leadGroup.groupListSearch}
      />
    );
  };

  private modalTitle = () => {
    const { leadGroup } = this.props.store;

    return leadGroup.modalStatus === LeadGroupModalStatus.OpenedOnGroupList
      ? 'Assign lead to group'
      : leadGroup.modalStatus === LeadGroupModalStatus.OpenedOnCreateGroup
      ? 'Create group'
      : leadGroup.modalStatus === LeadGroupModalStatus.OpenedOnSpecificGroup
      ? 'Assigning...'
      : '';
  };

  private handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.props.store.leadGroup.groupListSearch = e.currentTarget.value;
  };

  private handleBackToList = () => {
    this.props.store.leadGroup.modalStatus =
      LeadGroupModalStatus.OpenedOnGroupList;
    this.props.store.leadGroup.openedGroup = null;
  };

  private closeModal = () => {
    this.props.store.leadGroup.modalStatus = LeadGroupModalStatus.Closed;
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/BusinessGroup/BusinessGroupModal.tsx